/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IProveedores from 'Infotrack@Modelos/smartStock/proveedores/entidades/proveedores';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import ProveedoresCM from '../controladorModelo/proveedoresCM';
import { IFormularioProveedoresCVProps } from '../interfaces';
import { acciones, IEstadoProveedores } from '../reductorProveedores';
import FormularioProveedoresVista from '../vista/formularioProveedoresVista';
import { useSelector } from 'react-redux';

const estadoInicial: IProveedores = {
    EmpresaId: '',
    DescripcionProveedor: '',
    Estado: 1,
    AgenciaId: '',
    CodigoInternoCliente:''
};
const proveedoresCM = new ProveedoresCM();

const FormularioProveedoresCV: React.FunctionComponent<IFormularioProveedoresCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadProveedores }, dispatch] = useProveedor<IEstadoProveedores>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IProveedores>(estadoInicial);

    React.useEffect(() => {
        if (entidadProveedores && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadProveedores);
        } else {
            reiniciar();
        }
    }, [entidadProveedores]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionProveedores = () => {
        if (proveedoresCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarProveedores,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarProveedores = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            proveedoresCM
                .crearProveedores({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            proveedoresCM
                .editarProveedores({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioProveedoresVista
            accionCrearEditar={confirmarCreacionEdicionProveedores}
            cambiarInfoFomulario={alCambiarValor}
            proveedores={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioProveedoresCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioProveedoresCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioProveedoresCV);
